/** Minimal marketing page footer with a home link and a tagline. */
export function PageFooter({ tagline }: { tagline: string }) {
    return (
        <footer className="mktg-footer">
            <div className="mktg-container">
                <p className="mktg-footer__text">
                    <a href="/" className="mktg-footer__link">PDF Markup Tool</a>
                    {' -- '}
                    {tagline}
                </p>
            </div>
        </footer>
    );
}
